import { PersonSearchStorageVM } from 'shell/view-models/search-anpr';
import { FiltersPersonSearch } from './filters-person-search';

export const initialValuesPerson: PersonSearchStorageVM = {
  filters: {
    isChildComponentVisited: false,
    page: 0,
    rowsPerPage: 10,
    orders: {},
    subjectData: {
      fiscalCode: '',
    },
    identityCard: {
      number: '',
    },
    openedAccordion: FiltersPersonSearch.FiscalCode,
    isPersonsListVisited: false,
    residencePermit: {
      preccint: '',
      passportNumber: '',
      permitNumber: '',
    },
    searchByFiscalCode: {
      fiscalCode: '',
    },
    commonSearch: {
      municipalityOfResidence: null,
      isNationalResearch: false,
    },
  },
  subject: null,
};
